import React, { useRef, useLayoutEffect, useEffect, FC } from 'react';

export interface SingleOTPInputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    focus?: boolean;
}

export function usePrevious<T>(value?: T) {
    const ref = useRef<T>();

    // Store current value in ref
    useEffect(() => {
        ref.current = value;
    }, [value]); // Only re-run if value changes

    // Return previous value (happens before update in useEffect above)
    return ref.current;
}
export const SingleOTPInput: FC<SingleOTPInputProps> = (
    props: SingleOTPInputProps
) => {
    const { focus, autoFocus, ...rest } = props;
    const inputRef = useRef<HTMLInputElement>(null);

    const prevFocus = usePrevious(!!focus);
    useLayoutEffect(() => {
        if (inputRef.current) {
            if (focus && autoFocus) {
                inputRef.current.focus();
            }
            if (focus && autoFocus && focus !== prevFocus) {
                inputRef.current.focus();
                inputRef.current.select();
            }
        }
    }, [autoFocus, focus, prevFocus]);

    // eslint-disable-next-line react/jsx-props-no-spreading
    return <input ref={inputRef} {...rest} />;
};
export default SingleOTPInput;
